import { render } from "./IconDollar.vue?vue&type=template&id=046de422"
import script from "./IconDollar.vue?vue&type=script&lang=js"
export * from "./IconDollar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__